import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

// Action Text + Active Storage Direct Upload
import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Tailwind Plus custom elements (<el-dropdown>, <el-dialog>, command/commandfor)
// used by the marketing header. Bundled here instead of a runtime CDN script.
import "@tailwindplus/elements"

// Re-apply theme on Turbo visits to prevent dark class loss during morphing
document.addEventListener("turbo:before-render", (event) => {
  let appearance
  try {
    appearance = localStorage.getItem("appearance")
  } catch (e) {}
  appearance = appearance || "system"
  const dark =
    appearance === "dark" ||
    (appearance === "system" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches)
  event.detail.newBody.closest("html")?.classList.toggle("dark", dark)
})

const application = Application.start()
application.debug = false
window.Stimulus = application

// Import controllers
import HelloController from "./controllers/hello_controller"
application.register("hello", HelloController)

import DashboardChartController from "./controllers/dashboard_chart_controller"
application.register("dashboard-chart", DashboardChartController)

import DashboardTimelineController from "./controllers/dashboard_timeline_controller"
application.register("dashboard-timeline", DashboardTimelineController)

import DashboardFilterController from "./controllers/dashboard_filter_controller"
application.register("dashboard-filter", DashboardFilterController)

import TrackMapController from "./controllers/track_map_controller"
application.register("track-map", TrackMapController)

import TelemetryChartController from "./controllers/telemetry_chart_controller"
application.register("telemetry-chart", TelemetryChartController)

import TelemetryTabsController from "./controllers/telemetry_tabs_controller"
application.register("telemetry-tabs", TelemetryTabsController)

import PitWallController from "./controllers/pit_wall_controller"
application.register("pit-wall", PitWallController)

import LeaderboardController from "./controllers/leaderboard_controller"
application.register("leaderboard", LeaderboardController)

import LiveTrackMapController from "./controllers/live_track_map_controller"
application.register("live-track-map", LiveTrackMapController)

import ReplayController from "./controllers/replay_controller"
application.register("replay", ReplayController)

import LapListController from "./controllers/lap_list_controller"
application.register("lap-list", LapListController)

import ResizableSidebarController from "./controllers/resizable_sidebar_controller"
application.register("resizable-sidebar", ResizableSidebarController)

import SidebarToggleController from "./controllers/sidebar_toggle_controller"
application.register("sidebar-toggle", SidebarToggleController)

import StintSparklineController from "./controllers/stint_sparkline_controller"
application.register("stint-sparkline", StintSparklineController)

import UserMenuController from "./controllers/user_menu_controller"
application.register("user-menu", UserMenuController)

import PopoverController from "./controllers/popover_controller"
application.register("popover", PopoverController)

import UserSearchController from "./controllers/user_search_controller"
application.register("user-search", UserSearchController)

import NavSidebarController from "./controllers/nav_sidebar_controller"
application.register("nav-sidebar", NavSidebarController)

import EventSearchController from "./controllers/event_search_controller"
application.register("event-search", EventSearchController)

import FriendSearchController from "./controllers/friend_search_controller"
application.register("friend-search", FriendSearchController)

import EventSelectController from "./controllers/event_select_controller"
application.register("event-select", EventSelectController)

import EventGroupController from "./controllers/event_group_controller"
application.register("event-group", EventGroupController)

import RangePickerController from "./controllers/range_picker_controller"
application.register("range-picker", RangePickerController)

import ClientStatusController from "./controllers/client_status_controller"
application.register("client-status", ClientStatusController)

import ConnectionController from "./controllers/connection_controller"
application.register("connection", ConnectionController)

import SpeedChartController from "./controllers/speed_chart_controller"
application.register("speed-chart", SpeedChartController)

import EventCarouselController from "./controllers/event_carousel_controller"
application.register("event-carousel", EventCarouselController)

import ReleaseStatusController from "./controllers/release_status_controller"
application.register("release-status", ReleaseStatusController)

import ConfirmDialogController from "./controllers/confirm_dialog_controller"
application.register("confirm-dialog", ConfirmDialogController)

import CmdkController from "./controllers/cmdk_controller"
application.register("cmdk", CmdkController)

import ClipboardController from "./controllers/clipboard_controller"
application.register("clipboard", ClipboardController)

import RoleSelectController from "./controllers/role_select_controller"
application.register("role-select", RoleSelectController)

import FriendComboboxController from "./controllers/friend_combobox_controller"
application.register("friend-combobox", FriendComboboxController)

import LayerMenuController from "./controllers/layer_menu_controller"
application.register("layer-menu", LayerMenuController)

import ComparePickerController from "./controllers/compare_picker_controller"
application.register("compare-picker", ComparePickerController)

import TrackMiniMapController from "./controllers/track_mini_map_controller"
application.register("track-mini-map", TrackMiniMapController)

import TrackMapHeroController from "./controllers/track_map_hero_controller"
application.register("track-map-hero", TrackMapHeroController)

import TrackOrientationController from "./controllers/track_orientation_controller"
application.register("track-orientation", TrackOrientationController)

import MediaController from "./controllers/media_controller"
application.register("media", MediaController)

import PositionSparklineController from "./controllers/position_sparkline_controller"
application.register("position-sparkline", PositionSparklineController)

import TooltipController from "./controllers/tooltip_controller"
application.register("tooltip", TooltipController)

import DurationFieldController from "./controllers/duration_field_controller"
import DrawerController from "./controllers/drawer_controller"
application.register("duration-field", DurationFieldController)
application.register("drawer", DrawerController)

import DropdownController from "./controllers/dropdown_controller"
application.register("dropdown", DropdownController)

import TabsController from "./controllers/tabs_controller"
application.register("tabs", TabsController)

import SetupAccordionController from "./controllers/setup_accordion_controller"
application.register("setup-accordion", SetupAccordionController)

import MapPanelController from "./controllers/map_panel_controller"
application.register("map-panel", MapPanelController)

import FriendDragController from "./controllers/friend_drag_controller"
application.register("friend-drag", FriendDragController)

import FriendsFilterController from "./controllers/friends_filter_controller"
application.register("friends-filter", FriendsFilterController)

import GroupsPanelController from "./controllers/groups_panel_controller"
application.register("groups-panel", GroupsPanelController)

import ActivityHeatmapController from "./controllers/activity_heatmap_controller"
application.register("activity-heatmap", ActivityHeatmapController)

import CalendarController from "./controllers/calendar_controller"
application.register("calendar", CalendarController)

import CalendarCreateController from "./controllers/calendar_create_controller"
application.register("calendar-create", CalendarCreateController)

import RecurrencePickerController from "./controllers/recurrence_picker_controller"
application.register("recurrence-picker", RecurrencePickerController)

import ReminderFieldsController from "./controllers/reminder_fields_controller"
application.register("reminder-fields", ReminderFieldsController)

import TrainingDayFieldsController from "./controllers/training_day_fields_controller"
application.register("training-day-fields", TrainingDayFieldsController)

import AddRoundController from "./controllers/add_round_controller"
application.register("add-round", AddRoundController)

import RoundCardController from "./controllers/round_card_controller"
import SeasonDrawerController from "./controllers/season_drawer_controller"
import CollapsibleSectionController from "./controllers/collapsible_section_controller"
import InlineFieldController from "./controllers/inline_field_controller"
import SeasonPlanController from "./controllers/season_plan_controller"
import TrixEditorController from "./controllers/trix_editor_controller"
import RacingDrawerController from "./controllers/racing_drawer_controller"
import RacingRoundController from "./controllers/racing_round_controller"
import RacingCountdownController from "./controllers/racing_countdown_controller"
import RacingSubscriptionController from "./controllers/racing_subscription_controller"
import RacingSeriesPickerController from "./controllers/racing_series_picker_controller"
import RacingEventRowController from "./controllers/racing_event_row_controller"
application.register("round-card", RoundCardController)
application.register("season-drawer", SeasonDrawerController)
application.register("collapsible-section", CollapsibleSectionController)
application.register("inline-field", InlineFieldController)
application.register("season-plan", SeasonPlanController)
application.register("trix-editor", TrixEditorController)
application.register("racing-drawer", RacingDrawerController)
application.register("racing-round", RacingRoundController)
application.register("racing-countdown", RacingCountdownController)
application.register("racing-subscription", RacingSubscriptionController)
application.register("racing-series-picker", RacingSeriesPickerController)
application.register("racing-event-row", RacingEventRowController)

import EventTrackFilterController from "./controllers/event_track_filter_controller"
application.register("event-track-filter", EventTrackFilterController)

import TrackPickerController from "./controllers/track_picker_controller"
import TrackSelectController from "./controllers/track_select_controller"
import PlanTrackController from "./controllers/plan_track_controller"
import PlanRowController from "./controllers/plan_row_controller"
application.register("track-picker", TrackPickerController)
application.register("track-select", TrackSelectController)
application.register("plan-track", PlanTrackController)
application.register("plan-row", PlanRowController)

import InviteModalController from "./controllers/invite_modal_controller"
application.register("invite-modal", InviteModalController)

import HelpTocController from "./controllers/help_toc_controller"
application.register("help-toc", HelpTocController)

import AppearanceController from "./controllers/appearance_controller"
application.register("appearance", AppearanceController)

import UrlReplaceController from "./controllers/url_replace_controller"
application.register("url-replace", UrlReplaceController)

import AdminTrackSearchController from "./controllers/admin_track_search_controller"
application.register("admin-track-search", AdminTrackSearchController)

import AdminTrackSelectController from "./controllers/admin_track_select_controller"
application.register("admin-track-select", AdminTrackSelectController)

import AdminTrackGroupsController from "./controllers/admin_track_groups_controller"
application.register("admin-track-groups", AdminTrackGroupsController)

import AdminTrackFilterController from "./controllers/admin_track_filter_controller"
application.register("admin-track-filter", AdminTrackFilterController)

import SessionScrubberController from "./controllers/session_scrubber_controller"
application.register("session-scrubber", SessionScrubberController)

import RulebookUploadController from "./controllers/rulebook_upload_controller"
application.register("rulebook-upload", RulebookUploadController)

import RulesAutosaveController from "./controllers/rules_autosave_controller"
application.register("rules-autosave", RulesAutosaveController)

import AutoSubmitController from "./controllers/auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import KeyVisualUploadController from "./controllers/key_visual_upload_controller"
application.register("key-visual-upload", KeyVisualUploadController)

import PublishModalController from "./controllers/publish_modal_controller"
application.register("publish-modal", PublishModalController)

import CarClassesFormController from "./controllers/car_classes_form_controller"
import ComboboxController from "./controllers/combobox_controller"
import SeasonWizardController from "./controllers/season_wizard_controller"
import SeasonDatesController from "./controllers/season_dates_controller"
import SeasonTilesController from "./controllers/season_tiles_controller"
import SeasonScheduleController from "./controllers/season_schedule_controller"
application.register("car-classes-form", CarClassesFormController)

import PointsSchemeController from "./controllers/points_scheme_controller"
application.register("points-scheme", PointsSchemeController)

import InlineFormController from "./controllers/inline_form_controller"
application.register("inline-form", InlineFormController)

import DlcBadgeController from "./controllers/dlc_badge_controller"
application.register("dlc-badge", DlcBadgeController)

import SeasonGuestsFormController from "./controllers/season_guests_form_controller"
application.register("season-guests-form", SeasonGuestsFormController)

import EditGroupModalController from "./controllers/edit_group_modal_controller"
application.register("edit-group-modal", EditGroupModalController)

import CharCounterController from "./controllers/char_counter_controller"
application.register("char-counter", CharCounterController)

import ImageDropzoneController from "./controllers/image_dropzone_controller"
application.register("image-dropzone", ImageDropzoneController)

import IosDropUploadController from "./controllers/ios_drop_upload_controller"
application.register("ios-drop-upload", IosDropUploadController)

import IosPanelController from "./controllers/ios_panel_controller"
application.register("ios-panel", IosPanelController)

import CoachingChatController from "./controllers/coaching_chat_controller"
application.register("coaching-chat", CoachingChatController)

import CoachingChaptersController from "./controllers/coaching_chapters_controller"
application.register("coaching-chapters", CoachingChaptersController)

import SettingsAutosaveController from "./controllers/settings_autosave_controller"
application.register("settings-autosave", SettingsAutosaveController)

import RacingEmailTogglesController from "./controllers/racing_email_toggles_controller"
application.register("racing-email-toggles", RacingEmailTogglesController)

import SavePillController from "./controllers/save_pill_controller"
application.register("save-pill", SavePillController)

import SettingsNavController from "./controllers/settings_nav_controller"
application.register("settings-nav", SettingsNavController)

import PopController from "./controllers/pop_controller"
application.register("pop", PopController)

import DisclosureController from "./controllers/disclosure_controller"
application.register("disclosure", DisclosureController)

import RevealController from "./controllers/reveal_controller"
application.register("reveal", RevealController)

import OverlayAtController from "./controllers/overlay_at_controller"
application.register("overlay-at", OverlayAtController)

import OverlayFeedController from "./controllers/overlay_feed_controller"
application.register("overlay-feed", OverlayFeedController)

import OverlayGroupController from "./controllers/overlay_group_controller"
application.register("overlay-group", OverlayGroupController)

import ChangelogGeneratingController from "./controllers/changelog_generating_controller"
application.register("changelog-generating", ChangelogGeneratingController)

import ChangelogEditorController from "./controllers/changelog_editor_controller"
application.register("changelog-editor", ChangelogEditorController)

import ChangelogPublishController from "./controllers/changelog_publish_controller"
application.register("changelog-publish", ChangelogPublishController)

import CollapsibleController from "./controllers/collapsible_controller"
application.register("collapsible", CollapsibleController)

import WidthProfileController from "./controllers/width_profile_controller"
application.register("width-profile", WidthProfileController)

import ActivityAnchorController from "./controllers/activity_anchor_controller"
application.register("activity-anchor", ActivityAnchorController)

import CornerEditorController from "./controllers/corner_editor_controller"
application.register("corner-editor", CornerEditorController)

import SectionEditorController from "./controllers/section_editor_controller"
application.register("section-editor", SectionEditorController)

import CornerCurationController from "./controllers/corner_curation_controller"
application.register("corner-curation", CornerCurationController)

import PaneSplitterController from "./controllers/pane_splitter_controller"
application.register("pane-splitter", PaneSplitterController)

import CornerTimelineController from "./controllers/corner_timeline_controller"
application.register("corner-timeline", CornerTimelineController)

import TrackCoverageController from "./controllers/track_coverage_controller"
application.register("track-coverage", TrackCoverageController)

import CornerHoverController from "./controllers/corner_hover_controller"
application.register("corner-hover", CornerHoverController)
application.register("combobox", ComboboxController)
application.register("season-wizard", SeasonWizardController)
application.register("season-dates", SeasonDatesController)
application.register("season-tiles", SeasonTilesController)
application.register("season-schedule", SeasonScheduleController)

export { application }
